module.exports = __webpack_public_path__ + "img/ppt.f10ac760.svg";